<template>
  <v-container v-if="isAuth" fluid fill-height>
    <v-card
      class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 offset-sm-2 col-sm-8 col-xs-12 offset-xs-0 elevation-12"
      width="100%"
    >
      <v-card-text class="text-center">
        <profile-avatar :me="me" />
        <role-visualization-card />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <profile-details :me="me" />
      </v-card-text>
      <v-card-text class="text-center pt-0 pb-3">
        <v-btn
          color="primary onPrimary--text"
          @click="passwordDialog = true"
          v-t="'user.changeYourPassword'"
        ></v-btn>
      </v-card-text>
    </v-card>
    <v-dialog v-if="passwordDialog" :value="passwordDialog" max-width="500" persistent>
      <profile-password-invira @closeDialog="passwordDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { RoleVisualizationCard } from '@dracul/user-frontend/src/components/RoleVisualizationCard';
import ProfileAvatar from '@dracul/user-frontend/src/pages/ProfilePage/ProfileAvatar';
import ProfileDetails from '@dracul/user-frontend/src/pages/ProfilePage/ProfileDetails';
import ProfilePasswordInvira from './ProfilePasswordInvira.vue';

export default {
  name: 'ProfilePageInvira',
  components: {
    ProfilePasswordInvira,
    ProfileDetails,
    ProfileAvatar,
    RoleVisualizationCard,
  },
  data: () => ({
    passwordDialog: false,
  }),
  computed: {
    ...mapGetters(['isAuth', 'me']),
  },
};
</script>
